import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'
import { FormLeadService } from '../../../services/FormLead/FormLeadService'

export interface IFormLeadDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  leads: number[]
  onDelete: () => void
  leastDestructiveRef: any
}

export function FormLeadDeleteMultipleDialog({
  isOpen,
  onClose,
  leads,
  onDelete,
  leastDestructiveRef
}: IFormLeadDeleteDialogProps) {
  const service = new FormLeadService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await service.deleteMultiple(leads)

      toast({
        title: 'Leads deletados',
        description: 'Leads deletados com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onDelete()
      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao deletar leads',
        description: 'Erro ao deletar leads, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Deletar leads
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja deletar todos os lead marcados?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Deletar TODOS
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
